import { closeModal } from "../../../ui/containers/Modal";
import { floodFill } from "../../../ui/helpers";
import { ButtonComp } from "../../../ui/input/Button";
import { setScene } from "../../../ui/scene";
import { ALIGN_TYPE, TextType } from "../../../ui/type/TextType";
import { ComponentF, createElement } from "../../../ui/ui";
import Colors from "../../Colors";
import { Main } from "../../scenes/main";

export const VictoryModal: ComponentF<{
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C, props) => {
  floodFill(C.display, C.bounds, Colors.BLACK);
  C.handlers.keypress = (key: string) => {
    if (key === "Enter") {
      return false;
    }
    return true;
  };

  return [
    createElement(
      TextType,
      { x: 1, y: 0, w: C.bounds.w - 2, h: 1 },
      { title: "Atonement", align: ALIGN_TYPE.center }
    ),
    createElement(
      TextType,
      { x: 1, y: 1, w: C.bounds.w - 2, h: C.bounds.h - 2 },
      {
        title:
          "You have found peace among the ruins. As you make your final rest the world begins to stabilize around you.",
      }
    ),
    createElement(
      TextType,
      { x: 1, y: 8, w: C.bounds.w - 2, h: C.bounds.h - 2 },
      {
        title:
          "Thank you for playing, find me on Twitter @IAmSlogo or in the Roguelike Discord.",
      }
    ),
    createElement(
      ButtonComp,
      { x: 1, y: C.bounds.h - 2, w: C.bounds.w - 2, h: 1 },
      {
        title: "(Enter) End Game",
        keys: ["Escape", "Enter"],
        onClick: () => {
          closeModal();
          setScene(new Main());
        },
      }
    ),
  ];
};
